import dayjs from 'dayjs';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import { HYPERDRIVE } from 'utilities/constants';
import { HYPERWOLF } from 'utilities/constants';
import { HEMP } from 'utilities/constants';
import BreakIcon from 'common/customIcons/break';
import ReturnIcon from 'common/customIcons/return';
import StartIcon from 'common/customIcons/start';
import axios from 'axios';
import flagIcon from '../../assets/images/driveFlag.svg';
import darkMarker from '../../assets/images/icons/marker/greenmark.svg';
import notStartedMarker from '../../assets/images/icons/marker/yellowmarker.svg';
import inTransitMarker from '../../assets/images/icons/marker/purpulemark.svg';
import successMarker from '../../assets/images/icons/marker/redmark.svg';
import breakTaskMarker from '../../assets/images/icons/marker/break_task.svg';
import returnToHqMarker from '../../assets/images/icons/marker/return-to-head.svg';
import clusterMarker from '../../assets/images/icons/marker/greymark.svg';

export function getData(label) {
  if (typeof window !== 'undefined') {
    // Client-side-only code
    const data = window && window?.localStorage?.getItem(label);
    return data;
  }
}

export function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function setData(label, data) {
  if (typeof window !== 'undefined') {
    // Client-side-only code
    if (window && window?.localStorage)
      localStorage?.setItem(label, JSON.stringify(data));
  }
}

export function removeData(label) {
  if (typeof window !== 'undefined') {
    // Client-side-only code
    if (window && window.localStorage)
      localStorage.removeItem(label);
  }
}

export const getQueryString = (query = {}) => {
  const queryString = Object.keys(query)
    .reduce((acc, key) => {
      if (acc !== '') {
        acc += '&';
      }
      return acc + `${key}=${encodeURIComponent(query[key])}`;
    }, '');
  return queryString;
};

export const formatDate = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  const hours = date.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${month}/${day}/${year} ${displayHours}:${minutes} ${ampm}`;
};

export const formattedDate = (dateString) => {
  // Parse the original date string to a Date object
  const date = new Date(dateString);

  // Extract the year, month, and day
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
  const day = String(date.getDate()).padStart(2, '0');

  // Format the date as YYYY-MM-DD
  return `${year}-${month}-${day}`;
};

export const convertToTimestamp = (dateString) => {
  const date = new Date(dateString); // Create a Date object from the string
  const timestamp = date.getTime();
  return timestamp;
};

export const convertToTimestampWithMoment = (dateString) => {
  const timestamp = moment(dateString).valueOf();
  return timestamp;
};

export const formatTimestampToDate24Hours = (timestamp) => {
  // Assuming the timestamp is in milliseconds
  const formattedDate = dayjs(timestamp).format('MMM DD, YYYY hh:mm a');
  return formattedDate;
};

export const formatTimestampToDate24HoursBreak = (timestamp) => {
  const date = moment.utc(timestamp);
  const formattedDate = date.format('MMM DD, YYYY hh:mm a');
  return formattedDate;
};

export const formatTimestampToDate = (timestamp) => {
  // Assuming the timestamp is in milliseconds
  const formattedDate = dayjs(timestamp).format('DD-MM-YYYY HH:mm');
  return formattedDate;
};

export const formatTimestampToDateView = (timestamp) => {
  // Assuming the timestamp is in milliseconds
  const formattedDate = dayjs(timestamp).format('MMM DD, YYYY hh:mm a');
  return formattedDate ? formattedDate : '-';
};

export const formatTimestampToTimeWithTimezone = (timestamp, timezone) => {
  return dayjs(timestamp).tz(timezone).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
};

export const formatTimestampToTimeTimezone = (timestamp) => {
  return dayjs(timestamp).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
};

export const formatTimestampToMap = (timestamp) => {
  return dayjs(timestamp).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
};

export const formatTimestampToMapOld = (timestamp) => {
  return dayjs(timestamp).format('YYYY-MM-DD');
};

export const formatTimestampToWithoutTime = (timestamp) => {
  // Assuming the timestamp is in milliseconds
  const formattedDate = dayjs(timestamp).format('MMM DD, YYYY');
  return formattedDate;
};

export const formatTimestampToWithoutTimeToday = (timestamp) => {
  const date = dayjs(timestamp);
  const now = dayjs();

  // Check if the date is today
  if (date.isSame(now, 'day')) {
    return 'Today';
  }

  // Check if the date is yesterday
  if (date.isSame(now.subtract(1, 'day'), 'day')) {
    return 'Yesterday';
  }

  // Format the date if it's neither today nor yesterday
  return date.format('MMM DD, YYYY');
};

export const formatTimestampToWithoutTimeTodayTomorrow = (timestamp) => {
  const date = dayjs(timestamp);
  const now = dayjs();

  // Check if the date is today
  if (date.isSame(now, 'day')) {
    return 'Today 12 am';
  }
  if (date.isSame(now.add(1, 'day'), 'day')) {
    return 'Tomorrow 12 am';
  }

  // Format the date if it's neither today nor yesterday
  return date.format('MMM DD, YYYY');
};

export const formatTimestampToTime = (timestamp) => {
  // Assuming the timestamp is in milliseconds
  const formattedTime = dayjs(timestamp).format('HH:mm');
  return formattedTime;
};

export const formatTimestampToTimeAmPm = (timestamp) => {
  // Assuming the timestamp is in milliseconds
  const formattedTime = moment(timestamp).format('hh:mm A');
  return formattedTime;
};

export const formatTimestampTo12HourTime = (timestamp) => {
  // Assuming the timestamp is in milliseconds
  const formattedTime = dayjs(timestamp).format('hh:mm a');
  return formattedTime;
};

export const formatTimestampTo12HourTimeUtc = (timestamp) => {
  // Assuming the timestamp is in milliseconds
  // const formattedTime = dayjs(timestamp).format('hh:mm a');
  // return formattedTime;
  const date = moment.utc(timestamp);
  const formattedDate = date.format('hh:mm A');
  return formattedDate;
};

export function isEmptyObject(obj = {}) {
  // Using Object.keys() to get an array of object keys and checking its length
  return Object.keys(obj).length === 0;
}

export function isUnder21(dateOfBirth) {
  const dob = dayjs(dateOfBirth);
  const currentDate = dayjs();
  const age = currentDate.diff(dob, 'year');
  return age < 21;
}

export function formatAddress(deliveryAddress = {}) {
  // const { street, city, state, country } = address;
  const { address = '', city = '', state = '', zipcode = '', zipCode = '', apartment = '', country = '' } = deliveryAddress;

  // Using template literals to concatenate the address elements
  // const formattedAddress = `${street}, ${city}, ${state}, ${zipcode}`;

  // const formattedAddress = apartment ? `${apartment}, ${address}, ${city}, ${state}, ${zipcode || zipCode},${country}` : `${address}, ${city}, ${state}, ${zipcode || zipCode}, ${country}`;
  const formattedAddress = apartment ? `${apartment}, ${address}` : `${address}`;
  return formattedAddress;
}
export function formatAddressStilo(deliveryAddress = {}) {
  // const { street, city, state, country } = address;
  const { address, city, state, zipcode, zipCode } = deliveryAddress;

  // Using template literals to concatenate the address elements
  // const formattedAddress = `${street}, ${city}, ${state}, ${zipcode}`;
  const formattedAddress = `${address}, ${city}, ${state}, ${zipcode || zipCode ? zipcode || zipCode : ""}`;
  return formattedAddress;
}

export function formatDeliveryAddress(deliveryAddress) {
  const keysOrder = ['apartment', 'address', 'city', 'state', 'zipCode', 'country'];
  const result = [];

  for (const key of keysOrder) {
    if (deliveryAddress[key] && deliveryAddress[key].trim() !== '') {
      result.push(deliveryAddress[key].trim());
    }
  }

  return result.join(', ');
}

export function getPercentage(offeredPrice, salePrice) {
  if (salePrice === offeredPrice) return 100;
  return parseFloat(((offeredPrice - salePrice) / offeredPrice) * 100).toFixed(0);
}


export function isLoggedIn() {
  let user = JSON.parse(getData('login-user-info')) || {};
  if (user.access_token) return { isAuthenticated: true, user };
  else return { isAuthenticated: false };
}

export function logOut(userType) {
  return new Promise((res) => {
    localStorage.removeItem(userType);
    res(true);
  });
}

// awaiting_payment, awaiting_shipment, shipped, on_hold, cancelled, pending_fulfillment
export const orderStatus = [
  {
    key: 'awaiting_shipment',
    value: 'In Progress',
  },
  {
    key: 'shipped',
    value: 'On the way',
  },
  {
    key: 'cancelled',
    value: 'Cancelled',
  },
  {
    key: 'awaiting_payment',
    value: 'Payment Pending',
  },
  {
    key: 'on_hold',
    value: 'On Hold'
  },

];
export const orderDetailStiloStatus = [
  {
    key: "awaiting_shipment",
    value: 'In Progress',
  },
  {
    key: 'shipped',
    value: 'Shipped',
  },
  {
    key: 'placed',
    value: 'Placed',
  },
  {
    key: 'cancelled',
    value: 'Cancelled',
  },
  {
    key: 'awaiting_payment',
    value: 'Payment Pending',
  },
  {
    key: 'completed',
    value: 'Completed',
  },

]

export const orderDetailStatus = [
  {
    key: 'awaiting_shipment',
    value: 'In Progress',
  },
  {
    key: 'shipped',
    value: 'Shipped',
  },
  {
    key: 'cancelled',
    value: 'Cancelled',
  },
  {
    key: 'awaiting_payment',
    value: 'Payment Pending',
  },
  {
    key: 'delivered',
    value: 'Delivered',
  },
  // {
  //     key: 'not_returnable',
  //     value: 'Un-Returnable',
  // },
  {
    value: 'Delivery Failed',
    key: 'delivery_failed'
  },
  {
    value: 'Delivery Claim Filed',
    key: 'delivery_claimed_filed'
  },
];

export const returnRequestStatus = [
  {
    key: 'rejected',
    value: 'Rejected',
  },
  {
    key: 'approved',
    value: 'Approved',
  },
];

export const sortsBy = [
  {
    key: 'Today',
    value: 'today'
  },
  {
    key: '1 Week',
    value: 'week'
  },
  {
    key: '1 Month',
    value: 'month'
  },
  {
    key: '3 Months',
    value: 'threeMonths'
  },
  {
    key: 'All Time',
    value: 'All Time'
  },
  // {
  //     key: 'Custom',
  //     value: 'custom'
  // },
];

export const orderFilterTabs = [
  {
    key: 'All Orders',
    value: ''
  },
  {
    key: 'In-progress',
    value: 'awaiting_shipment'
  },
  {
    key: 'Shipped',
    value: 'shipped'
  },
  {
    key: 'Completed',
    value: 'delivered'
  },
  {
    key: 'Cancelled',
    value: 'cancelled'
  },
  // {
  //     key: 'Un-Returnable',
  //     value: 'not_returnable'
  // },
  {
    key: 'Warranty',
    value: 'warranty'
  },
  {
    key: 'Delivery Failed',
    value: 'delivery_failed'
  },
  {
    key: 'Delivery Claim Filed',
    value: 'delivery_claimed_filed'
  },
];



export const orderFilterTabsStilo = [
  {
    key: 'All Orders',
    value: ''
  },

  {
    key: 'Placed',
    value: 'placed'
  },
  {
    key: 'Completed',
    value: 'completed'
  },
  {
    key: 'Cancelled',
    value: 'cancelled'
  },

  // {
  //     key: 'Warranty',
  //     value: 'warranty'
  // },

];


export const driverFilterTabs = [
  {
    key: 'Drivers',
    value: ''
  },
  {
    key: 'Breaks',
    value: 'breaks'
  },
  {
    key: 'Approvals',
    value: 'approvals'
  }
];

export const strainsTabs = [
  {
    key: 'Strain Homepage',
    value: 'main_strains'
  },
  {
    key: 'Strains',
    value: 'strains'
  }
];

export const metrcTabs = [
  {
    key: 'promotion',
    value: 'promotion'
  },
  {
    key: 'Fee Management',
    value: 'FeeManagement'
  },
  // {
  //     key: 'compliance',
  //     value: 'compliance'
  // },
  // {
  //     key: 'delivery',
  //     value: 'delivery'
  // },
  {
    key: 'reward',
    value: 'reward'
  },
  // {
  //     key: 'taxes',
  //     value: 'taxes'
  // },
  // {
  //     key: 'member',
  //     value: 'member'
  // },
  {
    key: 'orders',
    value: 'orders'
  },
];

export const brandTabs = [
  {
    key: 'Brand Homepage',
    value: 'main_brands'
  },
  {
    key: 'Brands',
    value: 'brands'
  }
];

export const roleAndPermissionTabs = [
  {
    key: 'Users',
    value: 'users'
  },
  {
    key: 'Roles',
    value: 'roles'
  }
];

export function addCommas(number) {
  let [integerPart, decimalPart] = number?.toString().split('.');

  // Add commas to the integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Combine the integer and decimal parts with commas
  const formattedNumber = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;

  return formattedNumber;
}

export function addCommasWithToFixed(number) {
  if (!number) return '';
  number = Number(number)?.toFixed(2);
  // if (typeof number !== 'number') {
  //     throw new Error('Input must be a number.');
  // }

  // Convert the number to a string and split the decimal part
  let [integerPart, decimalPart] = number?.toString().split('.');

  // Add commas to the integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Combine the integer and decimal parts with commas
  const formattedNumber = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;

  return formattedNumber;
}

export function capitalizeText(text) {
  if (!text) return '';
  if (typeof text !== 'string') {
    throw new Error('Input should be a string');
  }

  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function addSpaceBeforeCapital(text) {
  return text.replace(/([A-Z])/g, ' $1').trim();
}


export function validatePassword(password) {
  // Minimum length of 8 characters
  const minLength = 8;
  // Require at least one uppercase letter, one lowercase letter, one digit, and one special character
  const uppercaseRegex = /[A-Z]/;
  const lowercaseRegex = /[a-z]/;
  const digitRegex = /\d/;
  const specialCharRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;

  // Check length
  if (password.length < minLength) {
    return false;
  }

  // Check for required character types
  if (!uppercaseRegex.test(password) || !lowercaseRegex.test(password) || !digitRegex.test(password) || !specialCharRegex.test(password)) {
    return false;
  }

  // If all checks pass, the password is considered valid
  return true;
}


export function formatUsPhoneNumber(phoneNumber) {
  // Remove any non-digit characters
  if (!phoneNumber) return '';
  const cleanedNumber = phoneNumber?.replace(/\D/g, '');



  // Format the phone number
  let formattedNumber;
  if (cleanedNumber.length > 10) {
    formattedNumber = `(${cleanedNumber.slice(1, 4)}) ${cleanedNumber.slice(4, 7)}-${cleanedNumber.slice(7)}`;
  }
  else {
    formattedNumber = `(${cleanedNumber.slice(0, 3)}) ${cleanedNumber.slice(3, 6)}-${cleanedNumber.slice(6)}`;
  }

  return formattedNumber;
}

export function formatBlazePhoneNumber(phoneNumber) {

  const cleanedNumber = phoneNumber?.replace(/^\+1/, '');

  const formattedNumber = `(${cleanedNumber?.slice(0, 3)}) ${cleanedNumber?.slice(3, 6)}-${cleanedNumber.slice(6)}`;
  return formattedNumber;

}

export function debounce(func, delay) {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export function separateUnitAndNumber(text) {
  // Define a regular expression to match a number followed by optional whitespace, and then an optional percentage sign
  const regex = /^(\d+(\.\d+)?)(\s*%)?(\s*([a-zA-Z]+))?$/;

  // Use the regular expression to match the text
  const match = text.match(regex);

  if (match) {
    // Extract the value and unit from the matched groups
    const value = parseFloat(match[1]);
    const unit = match[5] || null; // Use null if no unit is present

    // Return an object containing the value and unit
    return { value, unit };
  } else {
    // Return null if the text doesn't match the expected pattern
    return null;
  }
}

export function isNumber(value) {
  return /^\d+$/.test(value);
}

export function isNumberWithDot(value) {
  return /^\d+.$/.test(value);
}

export function isValidNumber(input) {
  const regex = /^\d+(\.\d+)?$/;
  return regex.test(+input);
}

export function isValidFileExtension(file, validExtensions) {
  const fileName = file?.name;
  const fileExtension = fileName.split('.').pop();
  return validExtensions.includes(fileExtension.toLowerCase());
}

export function generatePromoCodes(n) {
  const MAX_PROMO_CODES = 100;
  const count = Math.min(
    MAX_PROMO_CODES,
    Math.max(0, Number.parseInt(String(n ?? 0), 10) || 0)
  );
  const length = 7;
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  const promoCodes = [];

  for (let i = 0; i < count; i++) {
    let promoCode = '';
    for (let j = 0; j < length; j++) {
      promoCode += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    promoCodes.push(promoCode);
  }

  return promoCodes;
}

export const RolesAndPermissions = [
  {
    'Super Admin': {
      'Permissions': [
        'All'
      ]
    },

    'Shop Admin': {
      'Permissions': [
        'Products',
        'Orders',
        'Inventory',
        'Members',
        'Regions',
        'POS',
        'Banners',
        'Promotions'
      ]
    },
    'Shop Manager': {
      'Permissions': [
        'Products',
        'Orders',
        'Inventory',
        'Members',
        'Regions',
        'POS',
        'Banners',
        'Promotions'
      ]
    },
    'Inventory Manager': {
      'Permissions': [
        'Products',
        'Inventory',
        'Sub-categories',
        'Categories'
      ]
    },
    'Sales Associate': {
      'Permissions': [
        'Orders',
        'Members',
        'POS'
      ]
    },
    'Customer Support': {
      'Permissions': [
        'Orders',
        'Members',
        'POS'
      ]
    },
    'Marketing Manager': {
      'Permissions': [
        'Strains',
        'Terpenes (Cannabinoids)',
        'Categories',
        'Subcategories',
        'Brands - all',
        'FAQ - all',
        'Products - all',
        'Banners - all'
      ]
    },
    'Developer': {
      'Permissions': [
        'Admin'
      ]
    }
  }
];

export const downloadFile = (fileLink, fileName) => {
  return new Promise((resolve, reject) => {
    if (fileLink) {
      let link = document.createElement('a');
      link.href = fileLink;
      link.download = `${fileName}.csv`;
      link.click();
      return resolve(true);
    }
    else {
      return reject(false);
    }
  });
};

export const parseDate = (dateString) => {
  const format = 'DD-MM-YY HH:mm:ss';
  const parsed = dayjs(dateString, format);
  return parsed.isValid() ? parsed.format() : 'Invalid date';
};

export function generateEncryptedAuthKey() {
  let encrypted = CryptoJS.AES.encrypt(process.env.REACT_APP_API_AUTH_KEY, process.env.REACT_APP_AUTH_PHRASE_KEY, {
    mode: CryptoJS.mode.ECB,
  }).toString();
  return encrypted;
}


export function getImageExtension(filename) {
  // Check if the filename contains a period
  if (filename?.lastIndexOf('.') !== -1) {
    // Extract the substring from the last period to the end of the filename
    return filename?.substring(filename.lastIndexOf('.') + 1).toLowerCase();
  } else {
    // If no period is found, return an empty string
    return '';
  }
}

export const getLocaUserInfo = () => {
  if (typeof window !== 'undefined') {
    // Client-side-only code
    const data = window && window?.localStorage?.getItem('login-user-info');
    if (data) {
      return JSON.parse(data);
    }
    return {};
  }
};

export const getMarginToSale = (unitPrice, margin) => {
  const salePrice = +unitPrice * (100 + +margin) / 100;
  return salePrice;
};

export const getSaleToMargin = (unitPrice, salePrice) => {
  const margin = 100 * (+salePrice - +unitPrice) / +unitPrice;
  return margin;
};

export const calculateHundredYearsFromTimeStamp = (timestamp) => {
  const date = new Date(timestamp);
  date.setFullYear(date.getFullYear() + 150);
  return date;
};

export const categoryTabs = [
  {
    key: 'Sub categories',
    value: 'categories',
  },
  {
    key: 'Categories',
    value: 'manage_categories',
  }
];

export const categoryTabsStilo = [

  {
    key: 'Categories',
    value: 'manage_categories',
  }, {
    key: 'Sub categories',
    value: 'categories',
  }
];

export const cannabinoidsTabs = [
  {
    key: 'Home',
    value: 'main_cannabinoid'
  },
  {
    key: 'Cannabinoids',
    value: 'cannabinoids'
  }
];

export const strainsTab = [
  {
    key: 'Home',
    value: 'main_strain'
  },
  {
    key: 'Strains',
    value: 'strains'
  }
];

export const brandPageTab = [
  {
    key: 'Brand Homepage',
    value: 'main_brand'
  },
  {
    key: 'Brand',
    value: 'brand'
  }
];

export const adminsOptions = [
  {
    key: 'Hyperdrive',
    value: HYPERDRIVE
  },
  {
    key: 'Hyperwolf',
    value: HYPERWOLF
  },
  {
    key: 'Hemp',
    value: HEMP
  }
];

export const hyperdriveTaskOptions = [
  // {
  //     key: 'Pickup Task',
  //     value: 'pick_up_task'
  // },
  // {
  //     key: 'Drop Off Task',
  //     value: 'drop_off_task'
  // },
  {
    icon: <StartIcon />,
    key: 'Start Task',
    value: 'start_task'
  },
  {
    icon: <BreakIcon />,
    key: 'Break Task',
    value: 'break_task'
  },

  {

    icon: <ReturnIcon />,
    key: 'Return to HQ  Task',
    value: 'return_to_hq_task'
  },
];

export function convertMinutesToHoursAndMinutes(minutesInput) {
  const absoluteMinutes = Math.abs(minutesInput);
  const hours = Math.floor(absoluteMinutes / 60);
  const minutes = absoluteMinutes % 60;
  let output = '';

  if (hours > 0) {
    output += `${hours} Hours`;
  }
  if (minutes > 0) {
    if (output) {
      output += ' : ';
    }
    output += `${minutes} Minute(s)`;
  }

  return output.trim() ? output : '';
}

export const formatTime = (props) => {
  const hours = props?.hours;
  const minutes = props?.minutes;
  const seconds = props?.seconds;

  let timeParts = [];

  if (hours) {
    timeParts.push(`${hours} hour${hours === 1 ? '' : 's'}`);
  }
  if (minutes) {
    timeParts.push(`${minutes} min${minutes === 1 ? '' : 's'}`);
  }
  if (seconds) {
    timeParts.push(`${seconds} sec${seconds === 1 ? '' : 's'}`);
  }
  return timeParts.length > 0 ? timeParts.join(' ') : '-';
};

export const getDeliveryOptAndInstructions = (memo) => {
  if (!memo) return {};
  const lines = memo.split('\n').filter(line => line.includes(':'));
  const result = {};
  lines.forEach(line => {
    const [key, value] = line.split(':').map(item => item.trim());
    result[key] = value;
  });
  return result;
};

export function separateWords(input) {
  if (input === 'returnToHeadquarterTask') {
    return 'Return to HQ';
  }
  else {
    const separated = input?.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([a-z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/(?=[A-Z])|\s+/g, ' ');

    return separated ? separated.charAt(0).toUpperCase() + separated.slice(1) : '';
  }
}

export const formatPhoneNumber = (value) => {
  value = value.replace(/\D/g, '');
  // value = value.trim();

  // Check if the number starts with '+1'
  if (value.startsWith('+1')) {
    // return value; 
    return ` (${value.slice(0, 5)}) ${value.slice(5, 8)}-${value.slice(8)}`;
  }

  // Length check
  if (value.length < 10 || value.length > 11) {
    return 'Invalid number';
  }

  let formattedNumber;
  if (value.length === 10) {
    formattedNumber = `+1(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
  } else {
    formattedNumber = `+1(${value.slice(1, 4)}) ${value.slice(4, 7)}-${value.slice(7)}`;
  }

  return formattedNumber;
};

export const handleFileDownload = async () => {
  const user = getData('login-user-info');
  const parseUser = JSON.parse(user);

  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL_HYPER_DRIVE}/api/v1/admin/analyze/export`, {
      headers: {
        'Content-Type': 'application/octet-stream',
        Authorization: 'Bearer ' + parseUser?.access_token,
      },
      responseType: 'blob',
    });

    return response.data;

  } catch (error) {
    throw error;
  }
};


export const routeMap = [
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.66866868916643',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.65172933266915',
    'timestamp': 1728432787037
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67168070108572',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.65988066879359',
    'timestamp': 1728432818046
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67601826561325',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.66968916562556',
    'timestamp': 1728432849052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68369999376327',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.67569419252455',
    'timestamp': 1728432880051
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68957355462828',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.68347507483159',
    'timestamp': 1728432910067
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69532022310299',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.69180891256453',
    'timestamp': 1728432941049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.70015368358048',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.70183787413977',
    'timestamp': 1728432972065
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.70443817754148',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.71069436362208',
    'timestamp': 1728433003045
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.70992132571258',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.71849383470034',
    'timestamp': 1728433034044
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.707795316708015',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.72585556086054',
    'timestamp': 1728433065034
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69981393420139',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7332332878362',
    'timestamp': 1728433096053
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69129953970598',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.74068013050146',
    'timestamp': 1728433127055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.683178123149006',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.74754542923304',
    'timestamp': 1728433158049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67706863954747',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.75437093832797',
    'timestamp': 1728433189051
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.681722243222936',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76224013641959',
    'timestamp': 1728433220050
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68578408829504',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76536249425943',
    'timestamp': 1728433251052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.6881798235707',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76671729405699',
    'timestamp': 1728433282059
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69057980367256',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76705898785417',
    'timestamp': 1728433313049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69056422500595',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7670289776808',
    'timestamp': 1728433344055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68984102199852',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76857290176642',
    'timestamp': 1728433375057
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.685351463420105',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77306969830376',
    'timestamp': 1728433406052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.681762051257486',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77666135348012',
    'timestamp': 1728433437049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67981771080124',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77860115218394',
    'timestamp': 1728433468054
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.6797178600826',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77869969782606',
    'timestamp': 1728433499057
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67971770474624',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77869985054984',
    'timestamp': 1728433530046
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.679728709379845',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77868903064825',
    'timestamp': 1728433561048
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68276841504799',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78320900363849',
    'timestamp': 1728433592056
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68562778990608',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78731118194501',
    'timestamp': 1728433623053
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68616597644114',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78808410451374',
    'timestamp': 1728433654037
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.686162277358775',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78807876980117',
    'timestamp': 1728433685046
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.686154297847985',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78806726217174',
    'timestamp': 1728433716052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68650159575154',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78856590690765',
    'timestamp': 1728433747056
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.690840051170895',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7948186372932',
    'timestamp': 1728433778043
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69302113749564',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79795067902896',
    'timestamp': 1728433809044
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.6931381099649',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79811993254386',
    'timestamp': 1728433840051
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.693147274920904',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79813321184974',
    'timestamp': 1728433871049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.693140359628984',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7981231921339',
    'timestamp': 1728433902038
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69338825760209',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79848175001383',
    'timestamp': 1728433933055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69033447252668',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80216063203255',
    'timestamp': 1728433964058
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.688536194709705',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80396886265817',
    'timestamp': 1728433995049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68853876464563',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80396632202702',
    'timestamp': 1728434025058
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.688536841435784',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.8039682233037',
    'timestamp': 1728434056055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.685115129606665',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80741211083908',
    'timestamp': 1728434087041
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.683967643190634',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80856103181043',
    'timestamp': 1728434118058
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68146949078836',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81224871038101',
    'timestamp': 1728434149055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68209317382873',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.8135049604778',
    'timestamp': 1728434180052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68208957287546',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81349490553364',
    'timestamp': 1728434211047
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68046143865204',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81488025770511',
    'timestamp': 1728434242051
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.6798712137342',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81478411846972',
    'timestamp': 1728434273054
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67987781375229',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81477665209987',
    'timestamp': 1728434304046
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.679862883517394',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81478043338632',
    'timestamp': 1728434335045
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67986383713651',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.8147696726389',
    'timestamp': 1728434366039
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67990991962565',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.8146823024891',
    'timestamp': 1728434397041
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68082709571407',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81446171083003',
    'timestamp': 1728434428045
  },

  {
    'latitude': '33.66082709571335',
    'longitude': '-117.82348892834324'
  },
  {
    'latitude': '33.65578734544545',
    'longitude': '-117.81554334893434'
  },
  {
    'latitude': '33.73495949554988',
    'longitude': '-117.83255433494238'
  },
  {
    'latitude': '33.76393983790899',
    'longitude': '-117.74949383839348'
  },
  {
    'latitude': '33.78985489343499',
    'longitude': '-117.84374723982398'
  },
  {
    'latitude': '33.789943348347384',
    'longitude': '-117.894774588483867'
  },
  {
    'latitude': '33.7489430348884399',
    'longitude': '-117.895873927723728'
  },
  {
    'latitude': '33.74545783848843347',
    'longitude': '-117.8968483483283238'
  },
  {
    'latitude': '33.74633289887833894',
    'longitude': '-117.898454787584858'
  },
  {
    'latitude': '33.75938348982948598',
    'longitude': '-117.899943793478893'
  },
  {
    'latitude': '33.759999878678438758',
    'longitude': '-117.8124845484584588'
  },
  {
    'latitude': '33.763674367637436789',
    'longitude': '-117.8338243849384984'
  },
  {
    'latitude': '33.7458459999445543434',
    'longitude': '-117.854995443434900954'
  },
  {
    'latitude': '33.7498933793390576589',
    'longitude': '-117.895523785485548958'
  },
  {
    'latitude': '33.79769905095659654534',
    'longitude': '-117.9858859939480659934'
  },
  {
    'latitude': '33.787948787783983882388',
    'longitude': '-117.79084383490384398348'
  },
  {
    'latitude': '33.74545784387883483',
    'longitude': '-117.89684578394895845'
  },
  {
    'latitude': '33.74633289854895845',
    'longitude': '-117.89845658975690589'
  },
  {
    'latitude': '33.75938348982934784',
    'longitude': '-117.89994379347883587'
  },
  {
    'latitude': '33.759999875489834438',
    'longitude': '-117.81248454845444467'
  },
  {
    'latitude': '33.764568798379389999',
    'longitude': '-117.83382438445890874'
  },
  {
    'latitude': '33.7823982838298933299',
    'longitude': '-117.803983889899338999'
  },
  {
    'latitude': '33.7988798478948732889',
    'longitude': '-117.8190250989876668542'
  },
  {
    'latitude': '33.7837789838893798074',
    'longitude': '-117.8278921213553422547'
  },
  {
    'latitude': '33.789872367787823788',
    'longitude': '-117.865755784263644563'
  },
  {
    'latitude': '33.743327798957676445',
    'longitude': '-117.8883238384098430982'
  },
  {
    'latitude': '33.7854634677958577828',
    'longitude': '-117.783479433489439900'
  },
  {
    'latitude': '33.7575342978823529878',
    'longitude': '-117.9898834874589948577'
  },
  {
    'latitude': '33.87554756958905733573',
    'longitude': '-117.8678789778626289789'
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67168070108572',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.65988066879359',
    'timestamp': 1728432818046
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67601826561325',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.66968916562556',
    'timestamp': 1728432849052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68369999376327',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.67569419252455',
    'timestamp': 1728432880051
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68957355462828',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.68347507483159',
    'timestamp': 1728432910067
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69532022310299',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.69180891256453',
    'timestamp': 1728432941049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.70015368358048',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.70183787413977',
    'timestamp': 1728432972065
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.70443817754148',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.71069436362208',
    'timestamp': 1728433003045
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.70992132571258',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.71849383470034',
    'timestamp': 1728433034044
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.707795316708015',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.72585556086054',
    'timestamp': 1728433065034
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69981393420139',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7332332878362',
    'timestamp': 1728433096053
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69129953970598',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.74068013050146',
    'timestamp': 1728433127055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.683178123149006',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.74754542923304',
    'timestamp': 1728433158049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67706863954747',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.75437093832797',
    'timestamp': 1728433189051
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.681722243222936',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76224013641959',
    'timestamp': 1728433220050
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68578408829504',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76536249425943',
    'timestamp': 1728433251052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.6881798235707',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76671729405699',
    'timestamp': 1728433282059
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69057980367256',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76705898785417',
    'timestamp': 1728433313049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69056422500595',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7670289776808',
    'timestamp': 1728433344055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68984102199852',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.76857290176642',
    'timestamp': 1728433375057
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.685351463420105',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77306969830376',
    'timestamp': 1728433406052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.681762051257486',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77666135348012',
    'timestamp': 1728433437049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67981771080124',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77860115218394',
    'timestamp': 1728433468054
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.6797178600826',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77869969782606',
    'timestamp': 1728433499057
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.67971770474624',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77869985054984',
    'timestamp': 1728433530046
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.679728709379845',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.77868903064825',
    'timestamp': 1728433561048
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68276841504799',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78320900363849',
    'timestamp': 1728433592056
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68562778990608',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78731118194501',
    'timestamp': 1728433623053
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68616597644114',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78808410451374',
    'timestamp': 1728433654037
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.686162277358775',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78807876980117',
    'timestamp': 1728433685046
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.686154297847985',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78806726217174',
    'timestamp': 1728433716052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68650159575154',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78856590690765',
    'timestamp': 1728433747056
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.690840051170895',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7948186372932',
    'timestamp': 1728433778043
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69302113749564',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79795067902896',
    'timestamp': 1728433809044
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.6931381099649',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79811993254386',
    'timestamp': 1728433840051
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.693147274920904',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79813321184974',
    'timestamp': 1728433871049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.693140359628984',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7981231921339',
    'timestamp': 1728433902038
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69338825760209',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79848175001383',
    'timestamp': 1728433933055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69033447252668',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80216063203255',
    'timestamp': 1728433964058
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.688536194709705',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80396886265817',
    'timestamp': 1728433995049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68853876464563',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80396632202702',
    'timestamp': 1728434025058
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.688536841435784',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.8039682233037',
    'timestamp': 1728434056055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.685115129606665',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80741211083908',
    'timestamp': 1728434087041
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.683967643190634',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80856103181043',
    'timestamp': 1728434118058
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68146949078836',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81224871038101',
    'timestamp': 1728434149055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68209317382873',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.8135049604778',
    'timestamp': 1728434180052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68208957287546',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81349490553364',
    'timestamp': 1728434211047
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68046143865204',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81488025770511',
    'timestamp': 1728434242051
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.686162277358775',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78807876980117',
    'timestamp': 1728433685046
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.686154297847985',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78806726217174',
    'timestamp': 1728433716052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68650159575154',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.78856590690765',
    'timestamp': 1728433747056
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.690840051170895',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7948186372932',
    'timestamp': 1728433778043
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69302113749564',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79795067902896',
    'timestamp': 1728433809044
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.6931381099649',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79811993254386',
    'timestamp': 1728433840051
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.693147274920904',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79813321184974',
    'timestamp': 1728433871049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.693140359628984',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.7981231921339',
    'timestamp': 1728433902038
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69338825760209',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.79848175001383',
    'timestamp': 1728433933055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.69033447252668',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80216063203255',
    'timestamp': 1728433964058
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.688536194709705',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80396886265817',
    'timestamp': 1728433995049
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68853876464563',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80396632202702',
    'timestamp': 1728434025058
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.688536841435784',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.8039682233037',
    'timestamp': 1728434056055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.685115129606665',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80741211083908',
    'timestamp': 1728434087041
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.683967643190634',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.80856103181043',
    'timestamp': 1728434118058
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68146949078836',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81224871038101',
    'timestamp': 1728434149055
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68209317382873',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.8135049604778',
    'timestamp': 1728434180052
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68208957287546',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81349490553364',
    'timestamp': 1728434211047
  },
  {
    'taskId': '6705b77344469702842d2fe1',
    'latitude': '33.68046143865204',
    'fleetId': '67038fe30d723f4c36d27de6',
    'longitude': '-117.81488025770511',
    'timestamp': 1728434242051
  },
];

export function base64ToBlob(base64, contentType) {
  const byteCharacters = atob(base64.split(',')[1]);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}

export function getUniqueByLatLng(data) {
  return data.filter((item, index, self) => {
    const key = `${item.address.latitude},${item.address.longitude}`;

    return index === self.findIndex(el => `${el.address.latitude},${el.address.longitude}` === key);
  });
}

export const mainAnnouncementsDataaa = [
  {
    _id: "65236627329787823972",
    announcement: "test",
    status: 'Active'
  }
]
// export const slugRegex = (value) => value.replace(/[^a-z0-9-]/g, '');
export const slugRegex = (value) => {
  return value
    .toLowerCase()               // Convert to lowercase
    .replace(/\s+/g, '-')       // Replace spaces with -
    .replace(/[^\w-]+/g, '')    // Remove all non-word chars (letters, numbers, underscores, hyphens)
    .replace(/-+/g, '-');
};
export const slugRegexHypen = (value) => {
  return value
    .toLowerCase()               // Convert to lowercase
    .replace(/\s+/g, '-')       // Replace spaces with -
    .replace(/[^\w\-\/]+/g, '') // Remove all non-word chars (letters, numbers, underscores, hyphens, slashes)
    .replace(/-+/g, '-');
};
export const slugRegexwithunderScor = (value) => value.replace(/[^a-z0-9-_]/g, '');


export const formatLegalId = (legalId) => {
  return legalId
    .split("_") // Split by underscore
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join back with space
};


export function removeAfterLastDot(input) {
  let lastDotIndex = input?.lastIndexOf(".");
  return lastDotIndex !== -1 ? input?.substring(0, lastDotIndex) : input;
}



export const formatAIResponse = (text) => {
  let formatted = text;

  // Convert triple backtick code blocks ```language\ncode``` to HTML
  formatted = formatted.replace(/```(\w+)?\n?([\s\S]*?)```/g, (match, language, code) => {
    const lang = language || 'text';
    const cleanCode = code.trim();
    return `<pre class="code-block" data-language="${lang}"><code>${escapeHtml(cleanCode)}</code></pre>`;
  });

  // Convert single backtick inline code `code` to HTML
  formatted = formatted.replace(/`([^`\n]+)`/g, '<code class="inline-code">$1</code>');

  // Convert **bold** to HTML bold
  formatted = formatted.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

  // Convert *italic* to HTML italic (but not if it's part of **bold**)
  formatted = formatted.replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, '<em>$1</em>');

  // Convert bullet points (*** or - or •) to proper HTML lists
  formatted = formatted.replace(/^\*\*\*\s*(.+)$/gm, '• $1');
  formatted = formatted.replace(/^-\s*(.+)$/gm, '• $1');

  // Convert line breaks to proper spacing
  formatted = formatted.replace(/\n\n/g, '<br><br>');
  formatted = formatted.replace(/\n/g, '<br>');

  return formatted;
};

// export function convertAndExtractMeta(rawInput) {
//     const metaTitleMatch = rawInput.match(/\*\*Meta Title:\*\*\s*([^\n]+)/);
//     const metaDescriptionMatch = rawInput.match(/\*\*Meta Description:\*\*\s*([^\n]+)/);

//     const metaTitle = metaTitleMatch ? metaTitleMatch[1].trim() : '';
//     const metaDescription = metaDescriptionMatch ? metaDescriptionMatch[1].trim() : '';

//     // Get content after '---'
//     const contentStart = rawInput.indexOf('---');
//     let content = contentStart !== -1 ? rawInput.slice(contentStart + 3).trim() : '';

//     // Replace markdown-style formatting with HTML
//     content = content
//         .replace(/^### (.*$)/gim, '<h3>$1</h3>')
//         .replace(/^## (.*$)/gim, '<h2>$1</h2>')
//         .replace(/^# (.*$)/gim, '<h1>$1</h1>')
//         .replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>');

//     // Clean up extra newlines
//     content = content.replace(/\n{2,}/g, '\n');

//     return {
//         metaTitle,
//         metaDescription,
//         content,
//     };
// }


/**
 * Converts raw AI response text into formatted HTML content
 * @param {string} rawInput - The raw text response from AI
 * @returns {string} - Formatted HTML content
 */
// export function formatAIResponse(rawInput) {
//     if (!rawInput) return '';

//     // Remove meta title and description markers
//     let formatted = rawInput
//         .replace(/\*\*Meta Title:\*\*.*\n/g, '')
//         .replace(/\*\*Meta Description:\*\*.*\n/g, '')
//         .replace(/---/g, '');

//     // Convert markdown headers to HTML
//     formatted = formatted
//         .replace(/^### (.*$)/gim, '<h3>$1</h3>')
//         .replace(/^## (.*$)/gim, '<h2>$1</h2>')
//         .replace(/^# (.*$)/gim, '<h1>$1</h1>');

//     // Convert bullet points to HTML lists
//     formatted = formatted.replace(/^\*\s*(.+)$/gm, '<li>$1</li>');
//     formatted = formatted.replace(/^-\s*(.+)$/gm, '<li>$1</li>');
//     formatted = formatted.replace(/^•\s*(.+)$/gm, '<li>$1</li>');

//     // Wrap consecutive list items in <ul> tags
//     formatted = formatted.replace(/(<li>.*<\/li>(\n|$))+/g, (match) => {
//         return `<ul>${match}</ul>`;
//     });

//     // Convert single backtick inline code `code` to HTML
//     formatted = formatted.replace(/`([^`\n]+)`/g, '<code class="inline-code">$1</code>');

//     // Convert **bold** to HTML bold
//     formatted = formatted.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

//     // Convert *italic* to HTML italic (but not if it's part of **bold**)
//     formatted = formatted.replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, '<em>$1</em>');

//     // Convert line breaks to proper spacing
//     formatted = formatted.replace(/\n\n/g, '<br><br>');
//     formatted = formatted.replace(/\n/g, '<br>');

//     // Clean up extra whitespace
//     formatted = formatted.trim();

//     return formatted;
// }

export const numberOnly = (value) => {
  if (!value || typeof value !== 'string') return;
  const numOnly = value?.replace(/[^0-9]/g, "");

  return numOnly;
}
export const liveDriverLocations = [
  {
    "latitude": 37.81394960981016,
    "fleetId": "67441e00f6722ecf2a1919d5",
    "longitude": -122.19543174210493,
    "fleetOnDutyStatus": true,
    "fleetStatus": "active",
    "fleetName": "Manisha Saini",
    "fleetEmail": "manisha.saini@techindustan.com",
    "fleetVehicleDetails": {
      "make": "",
      "model": "",
      "expirationDate": ""
    },
    "driverTaskStatus": "idle"
  },
  {
    "latitude": 37.8102448,
    "fleetId": "674427d4f6722ecf2a1919d9",
    "longitude": -122.26448409999999,
    "fleetOnDutyStatus": true,
    "fleetStatus": "active",
    "fleetName": "vivek chamyal",
    "fleetEmail": "vivek.chamyal@techindustan.com",
    "fleetVehicleDetails": {
      "licensePlate": "",
      "color": "",
      "year": "",
      "make": "",
      "model": "",
      "insuranceProvider": "",
      "policyNumber": "",
      "expirationDate": ""
    },
    "driverTaskStatus": "idle"
  },
  {
    "latitude": 37.80879334140325,
    "fleetId": "674427f3f6722ecf2a1919da",
    "longitude": -122.28290307137317,
    "fleetOnDutyStatus": true,
    "fleetStatus": "active",
    "fleetName": "Anish",
    "fleetEmail": "anish@techindustan.com",
    "fleetVehicleDetails": {
      "licensePlate": "",
      "color": "",
      "year": "",
      "make": "",
      "model": "",
      "insuranceProvider": "",
      "policyNumber": "",
      "expirationDate": ""
    },
    "driverTaskStatus": "idle"
  },
  {
    "latitude": 30.6815997,
    "fleetId": "67444b54f6722ecf2a1919e0",
    "longitude": 76.7264903,
    "fleetOnDutyStatus": true,
    "fleetStatus": "active",
    "fleetName": "Uday Pathania",
    "fleetEmail": "uday.pathania@techindustan.com",
    "fleetVehicleDetails": {
      "licensePlate": "HP 37_1234",
      "color": "Blue",
      "year": "2002",
      "make": "Toyota",
      "model": "Supra",
      "insuranceProvider": "XYZ Company",
      "policyNumber": "0007",
      "expirationDate": ""
    },
    "driverTaskStatus": "idle"
  },
  {
    "latitude": 37.785834,
    "fleetId": "61c01e465287bb4cb0ba9601",
    "longitude": -122.406417,
    "fleetOnDutyStatus": true,
    "fleetStatus": "active",
    "fleetName": "Shruti",
    "fleetEmail": "shruti@techindustan.com",
    "fleetVehicleDetails": {
      "licensePlate": "",
      "color": "",
      "year": "",
      "make": "",
      "model": "",
      "insuranceProvider": "",
      "policyNumber": "",
      "expirationDate": ""
    },
    "driverTaskStatus": "idle"
  }
]

export const driversLocation = {
  "message": "Task list shown successfully!",
  "data": [
    {
      "fleetId": "674427d4f6722ecf2a1919d9",
      "locationData": {
        "latitude": 37.8102448,
        "longitude": -122.26448409999999
      },
      "fleetName": "vivek chamyal",
      "fleetStatus": true,
      "tasks": [
        {
          "_id": "6891b32caea87376860a8535",
          "taskType": "deliveryTask",
          "fleetId": "674427d4f6722ecf2a1919d9",
          "recipientDetails": {
            "name": "Manisha Saini",
            "phone": "+19898989898",
            "notes": "Website"
          },
          "address": {
            "address1": "The Cathedral of Christ the Light, Harrison Street, Oakland, CA, USA",
            "city": "Oakland",
            "state": "CA",
            "zipcode": "94612",
            "country": "US",
            "latitude": 37.8103499,
            "longitude": -122.2631018
          },
          "transactionNumber": "1125605",
          "taskStartTime": "Aug 05, 2025 12:33 am",
          "taskEndTime": "Aug 05, 2025 12:36 am",
          "taskStatus": "not_started",
          "orderType": "asap",
          "taskOrderDistance": 0.3156573502181019,
          "createdDate": "Aug 05, 2025 12:30 am",
          "taskDisplayId": 1117,
          "actualTaskStartTime": "",
          "actualTaskEndTime": "",
          "fleet": {
            "locationData": {
              "latitude": 37.8102448,
              "longitude": -122.26448409999999
            },
            "_id": "674427d4f6722ecf2a1919d9",
            "fleetOnDutyStatus": true,
            "fleetName": "vivek chamyal",
            "fleetEmail": "vivek.chamyal@techindustan.com",
            "fleetPhone": "6546546446",
            "fleetTransportationTypeId": "66c475cfdae8251f40c999e2"
          }
        },
        {
          "_id": "6891af89aea87376860a4d48",
          "taskType": "deliveryTask",
          "fleetId": "674427d4f6722ecf2a1919d9",
          "recipientDetails": {
            "name": "Manisha Saini",
            "phone": "+19898989898",
            "notes": "Website"
          },
          "address": {
            "address1": "Oakland Pole + Dance, Grand Avenue, Adams Point, Oakland, CA, USA",
            "city": "Oakland",
            "state": "CA",
            "zipcode": "94610",
            "country": "US",
            "latitude": 37.8090868,
            "longitude": -122.2550697
          },
          "transactionNumber": "1125603",
          "taskStartTime": "Aug 05, 2025 12:17 am",
          "taskEndTime": "Aug 05, 2025 12:20 am",
          "taskStatus": "not_started",
          "orderType": "asap",
          "taskOrderDistance": 1.0762175798774654,
          "createdDate": "Aug 05, 2025 12:15 am",
          "taskDisplayId": 1116,
          "actualTaskStartTime": "",
          "actualTaskEndTime": "",
          "fleet": {
            "locationData": {
              "latitude": 37.8102448,
              "longitude": -122.26448409999999
            },
            "_id": "674427d4f6722ecf2a1919d9",
            "fleetOnDutyStatus": true,
            "fleetName": "vivek chamyal",
            "fleetEmail": "vivek.chamyal@techindustan.com",
            "fleetPhone": "6546546446",
            "fleetTransportationTypeId": "66c475cfdae8251f40c999e2"
          }
        }
      ],
      "count": 2
    }
  ],
  "totalTasks": 2
}

// Convert 24-hour time string (e.g., "15:00") to 12-hour format with AM/PM (e.g., "3:00 PM")
export function formatTimeTo12Hour(time24) {
  if (!time24) return "";

  const [hoursStr, minutesStr] = time24.split(':');
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12; // Convert 0 to 12
  const displayMinutes = minutes.toString().padStart(2, '0');

  return `${displayHours}:${displayMinutes} ${ampm}`;
}
export function convertToAmPm(time24) {
  const [hours, minutes] = time24.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
}


export function convertTimeRange(timeRange) {
  if (!timeRange) return "-"; // Handle undefined/null/empty input

  try {
    // Split the range into start and end times
    const [startTime, endTime] = timeRange.split(/[–-]/).map(time => time.trim());

    // Early return if times are missing/invalid
    if (!startTime || !endTime) return "-";

    // Convert a single time from 24h to 12h format
    const convertTime = (time) => {
      const [hours, minutes] = time.split(':').map(Number);
      if (isNaN(hours) || isNaN(minutes)) return "Invalid Time";

      const period = hours >= 12 ? 'PM' : 'AM';
      const adjustedHours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
      return `${adjustedHours}:${minutes.toString().padStart(2, '0')} ${period}`;
    };

    const start12h = convertTime(startTime);
    const end12h = convertTime(endTime);

    return `${start12h} – ${end12h}`;
  } catch (error) {
    return "-"; // Fallback on parsing errors
  }
}
// const coordinates = [[-122.26448409999999, 37.8102448]// Point A
// [-122.2631018, 37.8103499] // Point B
// [-122.2550697, 37.8090868] // Point C
// ]
// const coordinates = [[-122.26448409999999, 37.8102448]// Point A
// [-122.2631018, 37.8103499] // Point B
// [-122.2550697, 37.8090868] // Point C
// ]



export const hasValue = (value) => {
  if (typeof value !== 'object') return true;
  let myValues = []

  if (Array.isArray(value)) {
    myValues = value.filter(Boolean);
  } else {
    myValues = Object.values(value).filter(Boolean)
  }

  if (myValues.length === 0) return false;

  return myValues.some(item => {
    if (typeof item === 'object') {
      return hasValue(item);
    } else {
      return true;
    }
  })
};


export const formatCamelCase = (text) => {
  if (!text) return '';
  return text
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // insert space before capital letters
    .replace(/^./, str => str.toUpperCase()) // capitalize first letter
    .trim();
};

export const compareJson = (oldJson, newJson) => {
  return JSON.stringify(oldJson) === JSON.stringify(newJson);
}

export const formatTimeStampToDate = (timeStamp) => {
  return moment.utc(timeStamp).format("YYYY-MM-DD")
}
export function convertAndExtractMeta(rawInput) {
  const sectionLabel = (label) => label.replace(/\s+/g, '[\\s_]*');
  const metaTitleMatch =
    rawInput.match(/\*\*Meta Title:?\*\*\s*([^\n]+)/i) ||
    rawInput.match(/(?:\*\*|###)\s*Meta Title:?(?:\*\*)?\s*([^\n]+)/i) ||
    rawInput.match(/Meta Title:?\s*([^\n]+)/i) ||
    rawInput.match(new RegExp(`(?:^|\\n)\\s*${sectionLabel('META TITLE')}:?\\s*([^\\n]+)`, 'i'));
  const metaDescriptionMatch =
    rawInput.match(/\*\*Meta Description:?\*\*\s*([^\n]+)/i) ||
    rawInput.match(/(?:\*\*|###)\s*Meta Description:?(?:\*\*)?\s*([^\n]+)/i) ||
    rawInput.match(/Meta Description:?\s*([^\n]+)/i) ||
    rawInput.match(new RegExp(`(?:^|\\n)\\s*${sectionLabel('META DESCRIPTION')}:?\\s*([^\\n]+)`, 'i'));
  const metaTitle = metaTitleMatch ? metaTitleMatch[1].trim() : '';
  const metaDescription = metaDescriptionMatch ? metaDescriptionMatch[1].trim() : '';

  // Brand prompt: Short Description / Bottom Text / Long Description sections
  const shortMatch =
    rawInput.match(/\*\*Short Description:?\*\*\s*([\s\S]*?)(?=\n\s*\*\*Long Description|$)/i) ||
    rawInput.match(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*Short Description\b[^\n]*\n([\s\S]*?)(?=\n\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*Long Description\b|$)/i
    ) ||
    rawInput.match(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*SHORT[_\s]*DESCRIPTION\b[^\n]*\n([\s\S]*?)(?=\n\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*(?:BOTTOM[_\s]*TEXT|LONG[_\s]*DESCRIPTION)\b|$)/i
    );
  const longMatch =
    rawInput.match(/\*\*Long Description:?\*\*\s*([\s\S]*?)$/i) ||
    rawInput.match(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*Long Description\b[^\n]*\n([\s\S]*?)(?=\n\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*(?:SEO and Conversion Guidelines|Formatting Rules|Remember\b)|$)/i
    ) ||
    rawInput.match(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*BOTTOM[_\s]*TEXT\b[^\n]*\n([\s\S]*?)(?=\n\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*ALT[_\s]*TEXT\b|$)/i
    );
  let shortDescription = shortMatch ? shortMatch[1].trim() : '';
  let longDescription = longMatch ? longMatch[1].trim() : '';
  // Guard against model returning Long Description heading inside short section.
  shortDescription = shortDescription
    .replace(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:(?:\*\*)?\d+[\).\:-]\s*)?(?:\*\*)?\s*Long Description\b[\s\S]*$/i,
      ''
    )
    .trim();
  if (shortDescription) shortDescription = shortDescription.replace(/\n/g, '<br/>');
  if (longDescription) {
    longDescription = longDescription
      .replace(/^#### (.*$)/gim, '\n<h3>$1</h3>')
      .replace(/^### (.*$)/gim, '\n<h3>$1</h3>')
      .replace(/^## (.*$)/gim, '\n<h2>$1</h2>')
      .replace(/^# (.*$)/gim, '\n<h1>$1</h1>')
      .replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>')
      .replace(/\n{2,}/g, '</p><p>')
      .replace(/\n/g, '<br/>')
      .replace(/\n{2,}/g, '\n');
  }

  // Get content after '---'
  const contentStart = rawInput.indexOf('---');
  let content = contentStart !== -1 ? rawInput.slice(contentStart + 3).trim() : '';
  // content = content.replace(/\*\*Product Description:\*\*\s*([\s\S]+?)(?=\n\*\*|\n###|$)/g, '') || content.replace(/(?:\*\*|###)?\s*Product Description:\s*(?:\*\*)?\s*([\s\S]+?)(?=\n\*\*|\n###|$)/gi, '');


  content = content
    .replace(/^#### (.*$)/gim, '\n<h3>$1</h3>')
    .replace(/^### (.*$)/gim, '\n<h3>$1</h3>')
    .replace(/^## (.*$)/gim, '\n<h2>$1</h2>')
    .replace(/^# (.*$)/gim, '\n<h1>$1</h1>')
    .replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>')
    .replace(/\n{2,}/g, '</p><p>')       // paragraph breaks
    .replace(/\n/g, '<br/>')             // line breaks
    // Remove "Product Description" section in any format
    .replace(
      /(?:\*\*|#+)?\s*Product Description\s*:?\s*(?:\*\*)?\s*([\s\S]+?)(?=\n\*\*|\n#+|\n|$)/gi,
      ''
    );

  // Clean up extra newlines
  content = content.replace(/\n{2,}/g, '\n');

  return {
    metaTitle,
    metaDescription,
    content,
    shortDescription,
    longDescription,
  };
}
export function convertAndExtractStrainMeta(rawInput) {
  // Extract Meta Title
  let metaTitle = '';
  const metaTitleMatch = rawInput.match(/Meta Title:\s*\n([^\n]+)/i);
  if (metaTitleMatch) {
    metaTitle = metaTitleMatch[1].trim();
  }

  // Extract Meta Description
  let metaDescription = '';
  const metaDescMatch = rawInput.match(/Meta Description:\s*\n([^\n]+)/i);
  if (metaDescMatch) {
    metaDescription = metaDescMatch[1].trim();
  }

  // Extract Heading
  let heading = '';
  const headingMatch = rawInput.match(/Heading:\s*\n([^\n]+)/i);
  if (headingMatch) {
    heading = headingMatch[1].trim();
  }

    // Extract Heading
  let title2 = '';
  const title2Match = rawInput.match(/Title2:\s*\n([^\n]+)/i);
  if (title2Match) {
    title2 = title2Match[1].trim();
  }

  // Extract Long Description - EXACTLY between "Long Description:" and "FAQ:"
  // Using more precise boundary to ensure FAQ is excluded
  let longDescription = '';
  const longDescMatch = rawInput.match(/Long Description:\s*\n([\s\S]*?)(?=\n\s*FAQ:|\n\s*\[Question|$)/i);
  if (longDescMatch) {
    longDescription = longDescMatch[1].trim();
    
    // Safety check: Remove anything that looks like FAQ content
    const faqStartIndex = longDescription.search(/\n\s*FAQ:|\n\s*\[Question/i);
    if (faqStartIndex !== -1) {
      longDescription = longDescription.substring(0, faqStartIndex).trim();
    }
  }

  // Extract FAQ section separately
  let faq = [];
  const faqMatch = rawInput.match(/FAQ:\s*\n([\s\S]*?)(?=\n\s*IMAGE_ALT:|$)/i);
  
  if (faqMatch) {
    const faqContent = faqMatch[1];
    
    // Match each Question/Answer pair
    const qaRegex = /\[Question\s*\d+\]\s*\n(.*?)\n\[Answer\s*\d+\]\s*\n([\s\S]*?)(?=\n\[Question|\n\s*$)/gi;
    let match;
    
    while ((match = qaRegex.exec(faqContent)) !== null) {
      const question = match[1].trim();
      let answer = match[2].trim();
      
      if (question && answer) {
        faq.push({
          question: `<p>${question}</p>`,
          answer: `<p>${answer}</p>`
        });
      }
    }
  }

  // Extract IMAGE_ALT
  let altImage = '';
  const imageAltMatch = rawInput.match(/IMAGE_ALT:\s*\n([^\n]+)/i);
  if (imageAltMatch) {
    altImage = imageAltMatch[1].trim();
  }

  // Format long description with HTML (NO FAQ content)
  if (longDescription) {
    // First, do a final cleanup to remove any remaining FAQ patterns
    longDescription = longDescription
      .replace(/FAQ:[\s\S]*$/i, '')  // Remove anything after FAQ:
      .replace(/\[Question\s*\d+\][\s\S]*$/i, '')  // Remove any question patterns
      .trim();
    
    // Then apply HTML formatting
    longDescription = longDescription
      .replace(/^#### (.*$)/gim, '<h3>$1</h3>')
      .replace(/^### (.*$)/gim, '<h3>$1</h3>')
      .replace(/^## (.*$)/gim, '<h2>$1</h2>')
      .replace(/^# (.*$)/gim, '<h1>$1</h1>')
      .replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>')
      .replace(/\n{2,}/g, '</p><p>')
      .trim();
    
    // Wrap in paragraphs if not already wrapped
    if (longDescription && !longDescription.startsWith('<')) {
      longDescription = `<p>${longDescription.replace(/\n/g, '</p><p>')}</p>`;
    }
  }

  return {
    metaTitle,
    metaDescription,
    title: heading,
    title2:title2,
    longDescription,
    faq,
    altImage,
  };
}
export function convertAndExtracHWBrandtMeta(rawInput) {
  const sectionLabel = (label) => label.replace(/\s+/g, '[\\s_]*');
  const metaTitleMatch =
    rawInput.match(/\*\*Meta Title:?\*\*\s*([^\n]+)/i) ||
    rawInput.match(/(?:\*\*|###)\s*Meta Title:?(?:\*\*)?\s*([^\n]+)/i) ||
    rawInput.match(/Meta Title:?\s*([^\n]+)/i) ||
    rawInput.match(new RegExp(`(?:^|\\n)\\s*${sectionLabel('META TITLE')}:?\\s*([^\\n]+)`, 'i'));
  const metaDescriptionMatch =
    rawInput.match(/\*\*Meta Description:?\*\*\s*([^\n]+)/i) ||
    rawInput.match(/(?:\*\*|###)\s*Meta Description:?(?:\*\*)?\s*([^\n]+)/i) ||
    rawInput.match(/Meta Description:?\s*([^\n]+)/i) ||
    rawInput.match(new RegExp(`(?:^|\\n)\\s*${sectionLabel('META DESCRIPTION')}:?\\s*([^\\n]+)`, 'i'));
  const metaTitle = metaTitleMatch ? metaTitleMatch[1].trim() : '';
  const metaDescription = metaDescriptionMatch ? metaDescriptionMatch[1].trim() : '';

  // Brand prompt: Short Description / Bottom Text / Long Description sections
  const shortMatch =
    rawInput.match(/\*\*Short Description:?\*\*\s*([\s\S]*?)(?=\n\s*\*\*Long Description|$)/i) ||
    rawInput.match(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*Short Description\b[^\n]*\n([\s\S]*?)(?=\n\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*Long Description\b|$)/i
    ) ||
    rawInput.match(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*SHORT[_\s]*DESCRIPTION\b[^\n]*\n([\s\S]*?)(?=\n\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*(?:BOTTOM[_\s]*TEXT|LONG[_\s]*DESCRIPTION)\b|$)/i
    );
  const longMatch =
    rawInput.match(/\*\*Long Description:?\*\*\s*([\s\S]*?)$/i) ||
    rawInput.match(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*Long Description\b[^\n]*\n([\s\S]*?)(?=\n\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*(?:SEO and Conversion Guidelines|Formatting Rules|Remember\b)|$)/i
    ) ||
    rawInput.match(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*BOTTOM[_\s]*TEXT\b[^\n]*\n([\s\S]*?)(?=\n\s*(?:[-*]\s*)?(?:\d+[\).\:-]\s*)?(?:\*\*|###|##|#)?\s*ALT[_\s]*TEXT\b|$)/i
    );
  let shortDescription = shortMatch ? shortMatch[1].trim() : '';
  let longDescription = longMatch ? longMatch[1].trim() : '';
  // Guard against model returning Long Description heading inside short section.
  shortDescription = shortDescription
    .replace(
      /(?:^|\n)\s*(?:[-*]\s*)?(?:(?:\*\*)?\d+[\).\:-]\s*)?(?:\*\*)?\s*Long Description\b[\s\S]*$/i,
      ''
    )
    .trim();
  if (shortDescription) shortDescription = shortDescription.replace(/\n/g, '<br/>');
  if (longDescription) {
    longDescription = longDescription
      .replace(/^#### (.*$)/gim, '\n<h3>$1</h3>')
      .replace(/^### (.*$)/gim, '\n<h3>$1</h3>')
      .replace(/^## (.*$)/gim, '\n<h2>$1</h2>')
      .replace(/^# (.*$)/gim, '\n<h1>$1</h1>')
      .replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>')
      .replace(/\n{2,}/g, '</p><p>')
      .replace(/\n/g, '<br/>')
      .replace(/\n{2,}/g, '\n');
  }

  // Get content after '---'
  const contentStart = rawInput.indexOf('---');
  let content = contentStart !== -1 ? rawInput.slice(contentStart + 3).trim() : '';
  // content = content.replace(/\*\*Product Description:\*\*\s*([\s\S]+?)(?=\n\*\*|\n###|$)/g, '') || content.replace(/(?:\*\*|###)?\s*Product Description:\s*(?:\*\*)?\s*([\s\S]+?)(?=\n\*\*|\n###|$)/gi, '');


  content = content
    .replace(/^#### (.*$)/gim, '\n<h3>$1</h3>')
    .replace(/^### (.*$)/gim, '\n<h3>$1</h3>')
    .replace(/^## (.*$)/gim, '\n<h2>$1</h2>')
    .replace(/^# (.*$)/gim, '\n<h1>$1</h1>')
    .replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>')
    .replace(/\n{2,}/g, '</p><p>')       // paragraph breaks
    .replace(/\n/g, '<br/>')             // line breaks
    // Remove "Product Description" section in any format
    .replace(
      /(?:\*\*|#+)?\s*Product Description\s*:?\s*(?:\*\*)?\s*([\s\S]+?)(?=\n\*\*|\n#+|\n|$)/gi,
      ''
    );

  // Clean up extra newlines
  content = content.replace(/\n{2,}/g, '\n');

  return {
    metaTitle,
    metaDescription,
    content,
    shortDescription,
    longDescription,
  };
}
export const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export function getPermissionsByMode(userPermissions, mode) {
  if (!userPermissions || typeof userPermissions !== "object") return [];
  switch ((mode || "").toLowerCase()) {
    case "hemp":
      return Array.isArray(userPermissions.hempPermissions) ? userPermissions.hempPermissions : [];
    case "hyperwolf":
      return Array.isArray(userPermissions.hwPermissions) ? userPermissions.hwPermissions : [];
    case "stilo":
      return Array.isArray(userPermissions.stiloPermissions) ? userPermissions.stiloPermissions : [];
    case "hyperdrive":
      return Array.isArray(userPermissions.hyperdrivePermissions) ? userPermissions.hyperdrivePermissions : [];
    default:
      return [];
  }
}

export function hasSectionPermission(permissionsArray, sectionTitle, actionTitle) {
  if (!Array.isArray(permissionsArray)) return false;
  const section = permissionsArray.find(sec => sec.title === sectionTitle);
  if (!section || !Array.isArray(section.permissions)) return false;
  return section.permissions.some(
    perm => perm.title === actionTitle && perm.status === true
  );
}
export const TestingProduct = [
  {
    "active": true,
    "assets": [
      {
        "publicURL": "https://connect-files-public.s3.amazonaws.com/cfe39af8-11db-4101-a70d-4afd681ee17e-500x500.jpg"
      }
    ],
    "brand": {
      "id": "658ca9c2a68ed330c886349d",
      "created": 1703717314439,
      "modified": 1703717314439,
      "deleted": false,
      "updated": false,
      "companyId": "5f99fc0ee8a8da08def1e6f1",
      "name": "Whoa",
      "active": true,
      "website": null,
      "phoneNo": null,
      "brandLogo": {
        "id": null,
        "created": 1703717314435,
        "modified": 1703717314435,
        "deleted": false,
        "updated": false,
        "companyId": null,
        "name": null,
        "key": null,
        "type": null,
        "publicURL": null,
        "active": false,
        "priority": 0,
        "secured": true,
        "thumbURL": null,
        "mediumURL": null,
        "largeURL": null,
        "largeX2URL": null,
        "origURL": null,
        "platformFileUrl": null,
        "assetType": null
      },
      "vendorList": [],
      "externalId": null,
      "platformBrandId": null,
      "globalBrandId": "2ee8f411-398a-4b4a-bd64-e920a740ec53",
      "vendors": [],
      "thirdPartyBrandName": null,
      "default": false
    },
    "brandId": "658ca9c2a68ed330c886349d",
    "category": {
      "categoryId": "64adf1966ce92b286a11993b",
      "categoryName": "Premium Oil"
    },
    "customGramType": "GRAM",
    "customWeight": 0,
    "description": "",
    "id": "642a6f32a531f36ab6b81292",
    "instock": false,
    "name": "Dev & Waffles Melted Diamonds 1",
    "potency": false,
    "potencyAmount": {
      "thc": 0,
      "cbd": 0,
      "cbn": 0,
      "thca": 0,
      "cbda": 0,
      "cbg": 0,
      "maxThc": null,
      "maxCbd": null,
      "maxCbn": null,
      "maxThca": null,
      "maxCbda": null,
      "thcBatch": true,
      "cbdBatch": true,
      "cbdaBatch": true,
      "thcaBatch": true,
      "cbnBatch": true,
      "cbgBatch": true,
      "totalPotency": true,
      "mgPotency": true
    },
    "productType": "REGULAR",
    "productSaleType": "Both",
    "priceBreaks": {
      "id": "642a6f32a531f36ab6b81294",
      "created": 1680502578871,
      "modified": 1680502578871,
      "deleted": false,
      "updated": false,
      "companyId": "5f99fc0ee8a8da08def1e6f1",
      "priceBreakType": "OneGramUnit",
      "name": "1 each",
      "displayName": "1 gram Vape",
      "price": 22,
      "quantity": 1,
      "active": true,
      "priority": 0,
      "salePrice": null,
      "assignedPrice": 22
    },
    "showInWidget": true,
    "thc": 0,
    "thca": 0,
    "unitPrice": 22,
    "unitValue": 1,
    "weightPerUnit": "EACH",
    "totalSellableQuantity": 15,
    "totalConsumerOrderQuantity": 0,
    "tags": [
      "EDIBLE BIN",
      "Whoa",
      "Clearance"
    ],
    "created": 1764667658377,
    "modified": 1764667658377,
    "sellableQuantities": {
      "64680bf137ae115552516b65": 0,
      "646800fbf414b736debf0bce": 0,
      "64680d47c2c9193b2d2ca2b4": 0,
      "64680d8e8a48360dadd3238b": 0,
      "6467fe448a48360dadd19dbc": 0,
      "64680c821556760aa0e87d03": 0,
      "65bb03bdf4fef1752313bc0d": 0,
      "6147e7b9c6f3c564b81c7031": 0,
      "66efc7c92a3215316b91c443": 0,
      "65bb032fdde430430e82eed3": 0,
      "64681302b3b5137c149cdfae": 0,
      "64680cc6c8f3376405880e7c": 0,
      "6729da032ca83829873e6ecc": 0,
      "64680052cad3826626e5465f": 0,
      "61538d2ca755e9326af2a0cb": 0,
      "6467ff6cba6f884adaa52471": 0,
      "690c536bd3abe1b4daa82307": 0,
      "66ee7a2f548ea35d0eb554bf": 0,
      "65bb01cc418a2b5c17e6b075": 0,
      "no_region": 15,
      "65bb020b418a2b5c17e6b5e0": 0,
      "64680de36748c62bba69cade": 0,
      "68390e6b76f5467c349eec94": 0,
      "62905a5c088bf83fd507b30b": 485,
      "6467fd458a48360dadd18a20": 0
    },
    "sku": "H292PRO1",
    "productSlug": "dev-waffles-melted-diamonds-1-642a6f32a531f36ab6b81292",
    "websiteProductName": "Dev & Waffles Melted Diamonds 1",
    "isStockAvailable": true,
    "deliveryTag": "SCHEDULE",
    "blazePromo": {
      "isStrikeThrough": false,
      "salePrice": null,
      "percentage": null
    }
  },
  {
    "active": true,
    "assets": [
      {
        "publicURL": "https://connect-files-public.s3.amazonaws.com/cfe39af8-11db-4101-a70d-4afd681ee17e-500x500.jpg"
      }
    ],
    "brand": {
      "id": "605d1fe579e22508c3cd515e",
      "created": 1616715749658,
      "modified": 1668057434741,
      "deleted": false,
      "updated": false,
      "companyId": "5f99fc0ee8a8da08def1e6f1",
      "name": "Hyperwolf",
      "active": true,
      "website": "https://hyperwolf.com",
      "phoneNo": null,
      "brandLogo": {
        "id": null,
        "created": 1616715749656,
        "modified": 1616715749656,
        "deleted": false,
        "updated": false,
        "companyId": null,
        "name": null,
        "key": null,
        "type": null,
        "publicURL": null,
        "active": false,
        "priority": 0,
        "secured": true,
        "thumbURL": null,
        "mediumURL": null,
        "largeURL": null,
        "largeX2URL": null,
        "origURL": null,
        "platformFileUrl": null,
        "assetType": null
      },
      "vendorList": [],
      "externalId": null,
      "platformBrandId": null,
      "globalBrandId": "c258a14b-a8ce-40ef-b5bb-927ff44b0251",
      "vendors": [],
      "thirdPartyBrandName": null,
      "default": false
    },
    "brandId": "605d1fe579e22508c3cd515e",
    "category": {
      "categoryId": "64adf6b8412a1c76f9f43d83",
      "categoryName": "Gummies"
    },
    "customGramType": "GRAM",
    "customWeight": 0,
    "description": "",
    "id": "642a6eb55e71563ec3b98590",
    "instock": false,
    "name": "Dev & Waffles Melted Diamonds",
    "potency": false,
    "potencyAmount": {
      "thc": 0,
      "cbd": 0,
      "cbn": 0,
      "thca": 0,
      "cbda": 0,
      "cbg": 0,
      "maxThc": null,
      "maxCbd": null,
      "maxCbn": null,
      "maxThca": null,
      "maxCbda": null,
      "thcBatch": true,
      "cbdBatch": true,
      "cbdaBatch": true,
      "thcaBatch": true,
      "cbnBatch": true,
      "cbgBatch": true,
      "totalPotency": true,
      "mgPotency": true
    },
    "productType": "REGULAR",
    "productSaleType": "Both",
    "priceBreaks": {
      "id": "642a6eb55e71563ec3b98592",
      "created": 1680502453581,
      "modified": 1680502453581,
      "deleted": false,
      "updated": false,
      "companyId": "5f99fc0ee8a8da08def1e6f1",
      "priceBreakType": "OneGramUnit",
      "name": "1 each",
      "displayName": "1 gram Vape",
      "price": 50,
      "quantity": 1,
      "active": true,
      "priority": 0,
      "salePrice": null,
      "assignedPrice": 50
    },
    "showInWidget": true,
    "thc": 0,
    "thca": 0,
    "unitPrice": 50,
    "unitValue": 1,
    "weightPerUnit": "EACH",
    "totalSellableQuantity": 39,
    "totalConsumerOrderQuantity": 0,
    "tags": [
      "Clearance",
      "Bundle#2 for $30"
    ],
    "created": 1764667658854,
    "modified": 1764667658854,
    "sellableQuantities": {
      "64680bf137ae115552516b65": 0,
      "646800fbf414b736debf0bce": 0,
      "64680d47c2c9193b2d2ca2b4": 0,
      "64680d8e8a48360dadd3238b": 0,
      "6467fe448a48360dadd19dbc": 0,
      "64680c821556760aa0e87d03": 0,
      "65bb03bdf4fef1752313bc0d": 0,
      "6147e7b9c6f3c564b81c7031": 48,
      "66efc7c92a3215316b91c443": 0,
      "65bb032fdde430430e82eed3": 0,
      "64681302b3b5137c149cdfae": 0,
      "64680cc6c8f3376405880e7c": 0,
      "6729da032ca83829873e6ecc": 0,
      "64680052cad3826626e5465f": 2,
      "61538d2ca755e9326af2a0cb": 0,
      "6467ff6cba6f884adaa52471": 0,
      "690c536bd3abe1b4daa82307": 0,
      "66ee7a2f548ea35d0eb554bf": 0,
      "65bb01cc418a2b5c17e6b075": 0,
      "no_region": 39,
      "65bb020b418a2b5c17e6b5e0": 0,
      "64680de36748c62bba69cade": 0,
      "68390e6b76f5467c349eec94": 0,
      "62905a5c088bf83fd507b30b": 488,
      "6467fd458a48360dadd18a20": 0
    },
    "sku": "H590PRO1",
    "productSlug": "dev-waffles-melted-diamonds-642a6eb55e71563ec3b98590",
    "websiteProductName": "Dev & Waffles Melted Diamonds",
    "isStockAvailable": true,
    "deliveryTag": "BOTH",
    "blazePromo": {
      "isStrikeThrough": false,
      "salePrice": null,
      "percentage": null
    }
  },
  {
    "active": true,
    "assets": [
      {
        "publicURL": "https://connect-files-public.s3.amazonaws.com/cfe39af8-11db-4101-a70d-4afd681ee17e-500x500.jpg"
      }
    ],
    "brand": {
      "id": "605d1fe579e22508c3cd515e",
      "created": 1616715749658,
      "modified": 1668057434741,
      "deleted": false,
      "updated": false,
      "companyId": "5f99fc0ee8a8da08def1e6f1",
      "name": "Hyperwolf",
      "active": true,
      "website": "https://hyperwolf.com",
      "phoneNo": null,
      "brandLogo": {
        "id": null,
        "created": 1616715749656,
        "modified": 1616715749656,
        "deleted": false,
        "updated": false,
        "companyId": null,
        "name": null,
        "key": null,
        "type": null,
        "publicURL": null,
        "active": false,
        "priority": 0,
        "secured": true,
        "thumbURL": null,
        "mediumURL": null,
        "largeURL": null,
        "largeX2URL": null,
        "origURL": null,
        "platformFileUrl": null,
        "assetType": null
      },
      "vendorList": [],
      "externalId": null,
      "platformBrandId": null,
      "globalBrandId": "c258a14b-a8ce-40ef-b5bb-927ff44b0251",
      "vendors": [],
      "thirdPartyBrandName": null,
      "default": false
    },
    "brandId": "605d1fe579e22508c3cd515e",
    "category": {
      "categoryId": "64adf1966ce92b286a11993b",
      "categoryName": "Premium Oil"
    },
    "customGramType": "GRAM",
    "customWeight": 0,
    "description": "",
    "id": "642a75ff771234126fd2d313",
    "instock": false,
    "name": "Dev Apple Rings Melted Diamondz 10",
    "potency": false,
    "potencyAmount": {
      "thc": 805.9,
      "cbd": 0,
      "cbn": 0,
      "thca": 0,
      "cbda": 0,
      "cbg": 0,
      "maxThc": null,
      "maxCbd": null,
      "maxCbn": null,
      "maxThca": null,
      "maxCbda": null,
      "thcBatch": true,
      "cbdBatch": true,
      "cbdaBatch": true,
      "thcaBatch": true,
      "cbnBatch": true,
      "cbgBatch": true,
      "totalPotency": true,
      "mgPotency": true
    },
    "productType": "REGULAR",
    "productSaleType": "Both",
    "priceBreaks": {
      "id": "642a75ff771234126fd2d315",
      "created": 1680504319641,
      "modified": 1680504319641,
      "deleted": false,
      "updated": false,
      "companyId": "5f99fc0ee8a8da08def1e6f1",
      "priceBreakType": "OneGramUnit",
      "name": "1 each",
      "displayName": "1 gram Vape",
      "price": 22,
      "quantity": 1,
      "active": true,
      "priority": 0,
      "salePrice": null,
      "assignedPrice": 22
    },
    "showInWidget": true,
    "thc": 0,
    "thca": 0,
    "unitPrice": 22,
    "unitValue": 1,
    "weightPerUnit": "EACH",
    "totalSellableQuantity": 200,
    "totalConsumerOrderQuantity": 0,
    "tags": [
      "510 + Pods (Vape BOX 1)",
      "Hyperwolf",
      "Diamonds"
    ],
    "created": 1764676916104,
    "modified": 1764676916104,
    "sellableQuantities": {
      "64680bf137ae115552516b65": 0,
      "646800fbf414b736debf0bce": 0,
      "64680d47c2c9193b2d2ca2b4": 0,
      "64680d8e8a48360dadd3238b": 0,
      "6467fe448a48360dadd19dbc": 0,
      "64680c821556760aa0e87d03": 0,
      "65bb03bdf4fef1752313bc0d": 0,
      "6147e7b9c6f3c564b81c7031": 0,
      "66efc7c92a3215316b91c443": 0,
      "65bb032fdde430430e82eed3": 0,
      "64681302b3b5137c149cdfae": 0,
      "64680cc6c8f3376405880e7c": 0,
      "6729da032ca83829873e6ecc": 0,
      "64680052cad3826626e5465f": 0,
      "61538d2ca755e9326af2a0cb": 0,
      "6467ff6cba6f884adaa52471": 0,
      "690c536bd3abe1b4daa82307": 0,
      "66ee7a2f548ea35d0eb554bf": 0,
      "65bb01cc418a2b5c17e6b075": 0,
      "no_region": 200,
      "65bb020b418a2b5c17e6b5e0": 0,
      "64680de36748c62bba69cade": 0,
      "68390e6b76f5467c349eec94": 0,
      "62905a5c088bf83fd507b30b": 200,
      "6467fd458a48360dadd18a20": 0
    },
    "sku": "H313PRO1",
    "productSlug": "dev-apple-rings-melted-diamondz-10-642a75ff771234126fd2d313",
    "websiteProductName": "Dev Apple Rings Melted Diamondz 10",
    "isStockAvailable": true,
    "deliveryTag": "SCHEDULE",
    "blazePromo": {
      "isStrikeThrough": false,
      "salePrice": null,
      "percentage": null
    }
  },
  {
    "active": true,
    "assets": [
      {
        "publicURL": "https://connect-files-public.s3.amazonaws.com/cfe39af8-11db-4101-a70d-4afd681ee17e-500x500.jpg"
      }
    ],
    "brand": {
      "id": "605d1fe579e22508c3cd515e",
      "created": 1616715749658,
      "modified": 1668057434741,
      "deleted": false,
      "updated": false,
      "companyId": "5f99fc0ee8a8da08def1e6f1",
      "name": "Hyperwolf",
      "active": true,
      "website": "https://hyperwolf.com",
      "phoneNo": null,
      "brandLogo": {
        "id": null,
        "created": 1616715749656,
        "modified": 1616715749656,
        "deleted": false,
        "updated": false,
        "companyId": null,
        "name": null,
        "key": null,
        "type": null,
        "publicURL": null,
        "active": false,
        "priority": 0,
        "secured": true,
        "thumbURL": null,
        "mediumURL": null,
        "largeURL": null,
        "largeX2URL": null,
        "origURL": null,
        "platformFileUrl": null,
        "assetType": null
      },
      "vendorList": [],
      "externalId": null,
      "platformBrandId": null,
      "globalBrandId": "c258a14b-a8ce-40ef-b5bb-927ff44b0251",
      "vendors": [],
      "thirdPartyBrandName": null,
      "default": false
    },
    "brandId": "605d1fe579e22508c3cd515e",
    "category": {
      "categoryId": "64adf1966ce92b286a11993b",
      "categoryName": "Premium Oil"
    },
    "customGramType": "GRAM",
    "customWeight": 0,
    "description": "",
    "id": "642a6b4c294a173fa38be1d6",
    "instock": false,
    "name": "Dev Apple Rings Melted Diamondz 1",
    "potency": false,
    "potencyAmount": {
      "thc": 805.9,
      "cbd": 0,
      "cbn": 0,
      "thca": 0,
      "cbda": 0,
      "cbg": 0,
      "maxThc": null,
      "maxCbd": null,
      "maxCbn": null,
      "maxThca": null,
      "maxCbda": null,
      "thcBatch": true,
      "cbdBatch": true,
      "cbdaBatch": true,
      "thcaBatch": true,
      "cbnBatch": true,
      "cbgBatch": true,
      "totalPotency": true,
      "mgPotency": true
    },
    "productType": "REGULAR",
    "productSaleType": "Both",
    "priceBreaks": {
      "id": "642a6b4c294a173fa38be1d8",
      "created": 1680501580816,
      "modified": 1680501580816,
      "deleted": false,
      "updated": false,
      "companyId": "5f99fc0ee8a8da08def1e6f1",
      "priceBreakType": "OneGramUnit",
      "name": "1 each",
      "displayName": "1 gram Vape",
      "price": 22,
      "quantity": 1,
      "active": true,
      "priority": 0,
      "salePrice": null,
      "assignedPrice": 22
    },
    "showInWidget": true,
    "thc": 0,
    "thca": 0,
    "unitPrice": 22,
    "unitValue": 1,
    "weightPerUnit": "EACH",
    "totalSellableQuantity": 20,
    "totalConsumerOrderQuantity": 0,
    "tags": [
      "510 + Pods (Vape BOX 1)",
      "Hyperwolf",
      "Diamonds"
    ],
    "created": 1764677027780,
    "modified": 1764677027780,
    "sellableQuantities": {
      "64680bf137ae115552516b65": 0,
      "646800fbf414b736debf0bce": 0,
      "64680d47c2c9193b2d2ca2b4": 0,
      "64680d8e8a48360dadd3238b": 0,
      "6467fe448a48360dadd19dbc": 0,
      "64680c821556760aa0e87d03": 0,
      "65bb03bdf4fef1752313bc0d": 0,
      "6147e7b9c6f3c564b81c7031": 0,
      "66efc7c92a3215316b91c443": 0,
      "65bb032fdde430430e82eed3": 0,
      "64681302b3b5137c149cdfae": 0,
      "64680cc6c8f3376405880e7c": 0,
      "6729da032ca83829873e6ecc": 0,
      "64680052cad3826626e5465f": 0,
      "61538d2ca755e9326af2a0cb": 0,
      "6467ff6cba6f884adaa52471": 0,
      "690c536bd3abe1b4daa82307": 0,
      "66ee7a2f548ea35d0eb554bf": 0,
      "65bb01cc418a2b5c17e6b075": 0,
      "no_region": 20,
      "65bb020b418a2b5c17e6b5e0": 0,
      "64680de36748c62bba69cade": 0,
      "68390e6b76f5467c349eec94": 0,
      "62905a5c088bf83fd507b30b": 480,
      "6467fd458a48360dadd18a20": 0
    },
    "sku": "H1D6PRO1",
    "productSlug": "dev-apple-rings-melted-diamondz-1-642a6b4c294a173fa38be1d6",
    "websiteProductName": "Dev Apple Rings Melted Diamondz 1",
    "isStockAvailable": true,
    "deliveryTag": "SCHEDULE",
    "blazePromo": {
      "isStrikeThrough": false,
      "salePrice": null,
      "percentage": null
    }
  }
]


export const getAvailableQuantityByDelivery = ({
  blazeStatus = true,
  sellableQuantities = {},
  terminalQuantities = [],
  deliveryType = "",
  regionId = "",
} = {}) => {
  const normalizeRegionIds = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed.filter(Boolean);
      } catch (e) {
        // Not JSON, treat as single id string.
      }
      return value ? [value] : [];
    }
    if (value === undefined || value === null) return [];
    return [value].filter(Boolean);
  };
  const normalizedType = deliveryType?.toLowerCase() === "asap" ? "asap" : "schedule";

  if (!blazeStatus && normalizedType === "asap") {
    if (!Array.isArray(terminalQuantities) || !terminalQuantities.length) return 0;
    const updateMax = (current, value) => (value > current ? value : current);
    if (normalizedType === "schedule") {
      let maxQty = 0;
      for (const terminal of terminalQuantities) {
        if (terminal?.regionId !== null) continue;
        const qty = Number(terminal?.quantity);
        if (Number.isFinite(qty)) maxQty = updateMax(maxQty, qty);
      }
      return maxQty;
    }
    const validRegions = normalizeRegionIds(regionId);
    if (!validRegions.length) return 0;
    const regionSet = new Set(validRegions);
    let maxQty = 0;
    for (const terminal of terminalQuantities) {
      const region = terminal?.regionId;
      if (!region || !regionSet.has(region)) continue;
      const qty = Number(terminal?.quantity);
      if (Number.isFinite(qty)) maxQty = updateMax(maxQty, qty);
    }
    return maxQty;
  }

  const normalizedRegionKey = Array.isArray(regionId) ? regionId[0] : regionId;
  const key = normalizedType === "asap" ? normalizedRegionKey : "no_region";
  return sellableQuantities?.[key] ?? 0;
};

export const checkProductInventory = (regionId = "", product = {}, deliveryType = "", blazeStatus = true) => {
  const { product: itemDetails = {}, quantity } = product
  const { sellableQuantities = {}, terminalQuantities = [] } = itemDetails
  const availableQuantity = getAvailableQuantityByDelivery({
    blazeStatus,
    sellableQuantities,
    terminalQuantities,
    deliveryType,
    regionId,
  })
  return availableQuantity >= quantity
}


// -------------------------------- new logic--------------------------------------

export function getProductRegionsFromCart(cartProducts, dispatchRegionFromStorage) {
  if (!Array.isArray(cartProducts) || cartProducts.length === 0) return [];

  // Get and normalize dispatch region ID
  const normalizeDispatchRegion = () => {
    const storedValue = dispatchRegionFromStorage || [];
    if (!storedValue) return [];
    try {
      const parsed = storedValue;
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
      return [parsed].filter(Boolean);
    } catch (e) {
      // Not JSON, treat as single value
      return [storedValue].filter(Boolean);
    }
  };

  const dispatchRegionIds = normalizeDispatchRegion();
  const dispatchRegionSet = new Set(dispatchRegionIds);

  const allRegions = new Set();
  const cartProductQuantities = new Map(); // Track quantities per cart product

  cartProducts.forEach(cartProduct => {
    if (!cartProduct) return;

    let itemRegions = [];

    // Normalize regions: accept both 'regions' array and singular 'region'
    if (Array.isArray(cartProduct.regions)) {
      itemRegions = cartProduct.regions;
    } else if (cartProduct.region) {
      itemRegions = [cartProduct.region];
    }

    // Get terminalQuantities from cartProduct or nested product
    const terminalQuantities = cartProduct.terminalQuantities ||
      (cartProduct.product && cartProduct.product.terminalQuantities) ||
      [];

    // If regions missing, try to get from terminalQuantities
    if (itemRegions.length === 0) {
      if (terminalQuantities.length > 0) {
        itemRegions = terminalQuantities
          .map(tq => tq.regionId)
          .filter(region => region && region !== "no_region");
      }
      if (itemRegions.length === 0) {
        itemRegions = [undefined];
      }
    }

    // Filter out "no_region" from itemRegions
    itemRegions = itemRegions.filter(region => region !== "no_region" && region !== undefined);

    // Get the added quantity from cart product
    const addedQuantity = cartProduct.quantity || cartProduct.origQuantity || 1;

    // Store the cart product's quantity
    const productId = cartProduct.productId || (cartProduct.product && cartProduct.product.id) || undefined;
    if (productId) {
      cartProductQuantities.set(productId, addedQuantity);
    }

    // Map region to max quantity from terminalQuantities
    let regionQuantityMap = {};
    itemRegions.forEach(region => {
      // Find matching terminalQuantity entry by regionId
      const terminalQty = terminalQuantities.find(tq => tq.regionId === region);
      const maxQuantity = terminalQty ? (terminalQty.quantity || 1) : 1;
      // Store the max quantity for this region
      regionQuantityMap[region] = maxQuantity;
    });

    // Filter to only regions that exist in dispatch region ID
    const dispatchRegionQuantityMap = {};
    Object.entries(regionQuantityMap).forEach(([region, maxQty]) => {
      if (dispatchRegionSet.has(region)) {
        dispatchRegionQuantityMap[region] = maxQty;
      }
    });

    let regions;
    if (Object.keys(dispatchRegionQuantityMap).length > 0) {
      // Filter regions that have enough quantity
      regions = Object.entries(dispatchRegionQuantityMap)
        .filter(([region, maxQty]) => addedQuantity <= maxQty)
        .map(([region, maxQty]) => region);

      // If no regions have enough quantity, return empty array (out of stock)
      if (regions.length === 0) {
        regions = [];
      }
    } else {
      // If no regions match dispatch region ID, fallback to all regions where quantity is available
      regions = Object.entries(regionQuantityMap)
        .filter(([region, maxQty]) => addedQuantity <= maxQty)
        .map(([region, maxQty]) => region);

      // If no regions have enough quantity, return empty array (out of stock)
      if (regions.length === 0) {
        regions = [];
      }
    }

    // Add regions to the set
    if (productId !== undefined) {
      regions.forEach(region => {
        if (region && region !== "no_region") {
          allRegions.add(region);
        }
      });
    }
  });

  // Filter regions based on the logic you described
  const allRegionsArray = Array.from(allRegions);

  // If allRegionsArray is empty, it means at least one product is out of stock
  if (allRegionsArray.length === 0) {
    return []; // Return empty array to indicate out of stock
  }

  // If only one cart product, return all eligible regions
  if (cartProducts.length === 1) {
    return allRegionsArray;
  }

  // If multiple cart products, check if any product quantity exceeds region capacity
  const finalRegions = allRegionsArray.filter(region => {
    // For each region, check if all cart products can be fulfilled
    const regionCanFulfillAll = cartProducts.every(cartProduct => {
      const productId = cartProduct.productId || (cartProduct.product && cartProduct.product.id);
      const addedQuantity = cartProduct.quantity || cartProduct.origQuantity || 1;

      // Get terminalQuantities for this cart product
      const terminalQuantities = cartProduct.terminalQuantities ||
        (cartProduct.product && cartProduct.product.terminalQuantities) ||
        [];

      // Find the max quantity for this region
      const terminalQty = terminalQuantities.find(tq => tq.regionId === region);
      const maxQuantity = terminalQty ? (terminalQty.quantity || 1) : 1;

      // Check if this product's quantity can be fulfilled by this region
      return addedQuantity <= maxQuantity;
    });

    return regionCanFulfillAll;
  });

  return finalRegions.filter(region => region !== "no_region");
}

export const StaticUserData = [

  {
    "email": "manisha.saini@techindustan.com",
    "firstName": "Manisha",
    "lastName": "Saini",
    "fullName": "Shekhar",
    "id": "61b0321d175b3b72c21bbf4f",
    "Phone": "9898989898",
    "consumerId": "61b0321d175b3b72c21bbf4f",
  },
  {
    "email": "manisha.saini+12333@techindustan.com",
    "firstName": "test users",
    "lastName": "data",
    "fullName": "Kunal Kumar",
    "id": "627a082c42ac7b18e52eb924",
    "Phone": "8686868686",
    "consumerId": "627a082c42ac7b18e52eb924"
  },
  {
    "email": "dhruvraj+11@techindustan.com",
    "firstName": "Test",
    "lastName": "dev88",
    "fullName": "Tushar",
    "id": "63e9bdc314b06f6b8c0435fb",
    "Phone": "6565656565",
    "consumerId": "63e9bdc314b06f6b8c0435fb"
  },
  {
    "email": "man334saini@techindustan.com",
    "firstName": "Manisha",
    "lastName": "Saini",
    "fullName": "Manisha Saini",
    "id": "68b580ef18cd9a7e87074559",
    "Phone": "5552222222",
    "consumerId": "68b580ef18cd9a7e87074559"
  },
  {
    "email": "vivek.chamyal+819@techindustan.com",
    "firstName": "Vivek",
    "lastName": "Chamyal",
    "fullName": "Vivek Chamyal",
    "id": "65dda3692cf4174efaa85b7d",
    "Phone": "5552224545",
    "consumerId": "65dda3692cf4174efaa85b7d"
  },
  {
    "email": "vipan.sharma@techindustan.com",
    "firstName": "Vipan",
    "lastName": "Sharma",
    "fullName": "Vipan Sharma",
    "id": "64917df33eab780cec6a3e2b",
    "Phone": "5552226890",
    "consumerId": "64917df33eab780cec6a3e2b"

  },
  {
    "email": "manisha+22@techindustan.com",
    "firstName": "Tanya",
    "lastName": "Kashyap",
    "fullName": "Tanya Kashyap",
    "id": "62da76ad5865cb0506338b20",
    "Phone": "5552226666",
    "consumerId": "62da76ad5865cb0506338b20"
  }


]

export const getIsTomorrowHoliday = (holidayListingData = []) => {
  try {
    const timeZone = 'America/Los_Angeles';
    // Get current date in Los Angeles timezone
    const today = moment().tz(timeZone).startOf('day');
    const tomorrow = today.clone().add(1, 'day');
    // Format tomorrow as YYYY-MM-DD for comparison
    const tomorrowFormatted = tomorrow.format('YYYY-MM-DD');
    // Check if tomorrow matches any holiday date
    const isTomorrowHoliday = (holidayListingData || []).some(item => {
      // Accept possible fields: date, holidayDate, day
      const dateStr = item?.date || item?.holidayDate || item?.day;
      if (!dateStr) return false;
      // Parse the holiday date
      let holidayDate = moment(dateStr);
      if (!holidayDate.isValid()) {
        // Try different date formats if the first one fails
        holidayDate = moment(dateStr, ['YYYY-MM-DD', 'MM-DD-YYYY', 'DD-MM-YYYY']);
      }
      if (!holidayDate.isValid()) return false;
      // Format holiday date as YYYY-MM-DD for comparison
      const holidayFormatted = holidayDate.format('YYYY-MM-DD');
      // Compare formatted dates
      return holidayFormatted === tomorrowFormatted;
    });
    return isTomorrowHoliday;
  } catch (e) {
    return false;
  }
};

export const checkScheduledTimeV2 = ({ isTodayHoliday = false, isTomorrowHoliday = false, toDaySlots = [] } = {}) => {

  const timeZone = 'America/Los_Angeles';

  const addDays = isTodayHoliday ? 1 : (isTomorrowHoliday && toDaySlots?.length === 0 ? 2 : 1);

  return moment().tz(timeZone).startOf('day').add(addDays, 'day').format('dddd');
};

export const checkScheduledTimeTodayV2 = ({ isTodayHoliday = false, isTomorrowHoliday = false, toDaySlots = [] } = {}) => {

  const timeZone = 'America/Los_Angeles';
  const addDays = isTodayHoliday ? 1 : (isTomorrowHoliday && toDaySlots?.length === 0 ? 2 : 0);
  return moment().tz(timeZone).startOf('day').add(addDays, 'day').format('dddd');
};


export const BMW_HEADER = { "x-auth-token": process.env.REACT_APP_X_AUTH_TOKEN || "VRHRP60P0E0LXU1PZQJAB4FR8H3UXLV4LKPCFT8C" };

export const BlazeHeaders = {
  ...BMW_HEADER
}

export const stateList = [
  {
    value: 'california',
    label: 'California',
    stateCode: 'CA'
  },
  {
    value: 'new_jersey',
    label: 'New Jersey',
    stateCode: 'NJ'
  },
  {
    value: 'new_york',
    label: 'New York',
    stateCode: 'NY'
  }
]

export const getIconbyStatus = (status) => {

  switch (status) {
    case 'no_fleet': return flagIcon
    case 'completed': return darkMarker;
    case 'in_progress': return inTransitMarker;
    case 'not_started': return notStartedMarker;
    case 'cancelled': return successMarker;
    case 'startTask': return inTransitMarker;
    case 'breakTask': return breakTaskMarker;
    case 'returnToHeadquarterTask': return returnToHqMarker;
    case 'unassigned': return unassignedMarker;
    default: return darkMarker;
  }
};

export const convertBrandNameToSlug = (brandName) => {
  if (!brandName) return ""
  let brandSlug = ''
  brandSlug = brandName.toLowerCase()
  brandSlug = brandSlug.replace(/-/g, "-")
  brandSlug = brandSlug.replace(/ /g, "-")
  brandSlug = brandSlug.replace(/[^a-z0-9+]+/gi, "-")
  brandSlug = brandSlug.replace(/^\-+|\-+$/g, "")
  return brandSlug
}

export function calculateReadTime(contentArray) {
  if (!Array.isArray(contentArray)) return 0;

  const allText = contentArray
    .map(item => Object.values(item).join(" "))
    .join(" ");

  const cleanText = allText.replace(/<[^>]*>/g, "");

  const words = cleanText.trim().split(/\s+/).filter(Boolean).length;

  return Math.max(1, Math.ceil(words / 200)); // minimum 1 min
}

export const generateSku = () => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let result = '';
  const length = 8;
  for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}